// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_9e1425b4d3--wrapper--ZpTXJ","control":"_9e1425b4d3--control--EU3fv","back-image":"_9e1425b4d3--back-image--CyRBa"};